<template>
  <div class="empty-detail__wraper">
    <img class="empty-detail__image" src="@/assets/images/undraw.png" alt="undraw image">
    <div class="empty-detail__content">
      <h6>{{description}}</h6>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: 'Você ainda não preencheu nenhuma informação',
    }
  }
}
</script>

<style lang="scss">
.empty-detail__wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.empty-detail__image {
  width: 100px;
  height: 100px;
}

.empty-detail__content {
  display: flex;
  align-items: center;
  margin: 24px 0;
}
</style>